<template>
<div class="chapter">
<div class="inner_page">
<table class="chapter-title-corner-decorations" width="100%"><tbody><tr><td class="chapter-title-corner-decoration-left-column"><div class="chapter-title-corner-decoration-left-column"><img alt="image" class="chapter-title-corner-decoration-left" src="d2d_images/chapter_title_corner_decoration_left.png"/></div></td><td class="chapter-title-corner-decoration-middle-column"> </td><td class="chapter-title-corner-decoration-right-column"><div class="chapter-title-corner-decoration-right-column"><img alt="image" class="chapter-title-corner-decoration-right" src="d2d_images/chapter_title_corner_decoration_right.png"/></div></td></tr></tbody></table><div class="chapter-title"><div class="chapter-title-decoration-above"><div class="chapter-title-decoration-above-inner"><img alt="image" class="chapter-title-decoration-above" src="d2d_images/chapter_title_above.png"/></div></div><h1 class="chapter-title"><a href="#/c006#TOC">Copyright</a><a id="Copyright"></a></h1><a id="Copyright">
<div class="chapter-title-decoration-below"><div class="chapter-title-decoration-below-inner"><img alt="image" class="chapter-title-decoration-below" src="d2d_images/chapter_title_below.png"/></div></div></a></div><p style="text-align: center; text-indent: 0"><a id="Copyright"><img alt="image" class="section-break-symbol" height="189" src="d2d_images/image006.jpg" width="300"/></a></p><a id="Copyright">
</a><p style="text-align: center; text-decoration: underline; text-indent: 0"><a id="Copyright"></a><a href="https://www.EvolvedPub.com/" target="_blank">www.EvolvedPub.com</a></p>
<p style="text-align: center; text-indent: 0">Per essere sicuro di non perdere importanti annunci sui nostri libri, promozioni speciali, ecc., iscriviti alla nostra newsletter all’indirizzo qui sotto. E non temere, non ti manderemo spam, né daremo i tuoi dati ad altri.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c002.vue?4d8e880c